import { SUBSCRIPTION_TYPES } from '../constants/subscriptions';

export const subscriptions = {
  has_membership: viewer => viewer.user?.profile.reservationMembershipRequirementExempt
    ? 'exempt'
    : !!viewer.subscriptions.filter(s => s.status === SUBSCRIPTION_TYPES.ACTIVE).length
};
